module.exports = __webpack_public_path__ + "img/Group 27997@2x.04831215.png";